import { Card, CardActions, CardContent, CardHeader } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import { HelpButton } from '../HelpButton';
import KeyboardArrowDownIcon from '../Icons/KeyboardArrowDownIcon';
import RefreshIcon from '../Icons/RefreshIcon';
import ProjectStepsMenu from '../ProjectStepsMenu/ProjectStepsMenu';
import styles from './CustomCard.scss';
const rootClassName = styles.rootClassName;

class CustomCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      projectStepsMenuOpened: false,
      projectStepsMenuAnchor: null,
    };

    this.updateDimensions = this.updateDimensions.bind(this);
    this.toCloseProjectStepsMenu = this.toCloseProjectStepsMenu.bind(this);
    this.toOpenProjectStepsMenu = this.toOpenProjectStepsMenu.bind(this);
  }

  updateDimensions() {
    this.setState({
      ...this.state,
      isMobile: window.innerWidth < parseInt(styles.smSize) ? true : false,
    });
  }

  UNSAFE_componentWillMount() {
    this.updateDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  getCardActions() {
    const className = this.props.CardActionsPropTypes
      ? this.props.CardActionsPropTypes.className
      : '';
    const cardActionsProps = {
      ...(this.props.CardActionsPropTypes || {}),
      className: className + ' ' + rootClassName + '-actions',
    };
    if (
      this.props.cardActionsContentLeft ||
      this.props.cardActionsContentRight
    ) {
      const contentLeft = this.props.cardActionsContentLeft ? (
        <div className={rootClassName + '-actions-left'}>
          {this.props.cardActionsContentLeft}
        </div>
      ) : (
        ''
      );
      const contentRight = this.props.cardActionsContentRight ? (
        <div className={rootClassName + '-actions-right'}>
          {this.props.cardActionsContentRight}
        </div>
      ) : (
        ''
      );
      return (
        <CardActions {...cardActionsProps}>
          <div></div>
          {contentLeft}
          {contentRight}
        </CardActions>
      );
    }
    return <></>;
  }

  getHint() {
    if (this.props.titleHint) {
      return (
        <HelpButton
          text={this.props.titleHint}
          className={rootClassName + '-step-header-hint-button'}
        />
      );
    }
    return '';
  }

  getSendingIcon() {
    if (!this.props.sending) {
      return '';
    }
    return (
      <RefreshIcon
        className={getMergedClassNames([rootClassName + '-sending-icon'])}
      />
    );
  }

  getSubHeader() {
    return (
      <>
        {this.getHint()}
        {this.getSendingIcon()}
      </>
    );
  }

  toOpenProjectStepsMenu(event) {
    this.setState({
      ...this.state,
      projectStepsMenuOpened: true,
      projectStepsMenuAnchor: event.currentTarget,
    });
  }

  toCloseProjectStepsMenu() {
    this.setState({
      ...this.state,
      projectStepsMenuOpened: false,
    });
  }

  getAllStatus() {
    let status = [];
    this.props.projeto.avaliacoes.map((currStatus, index) => {
      status.push(currStatus.status);
      return index;
    });
    return status;
  }

  allowStepsMenu() {
    return this.props.auth.userPermissions.projetos.edit;
  }

  getTitle() {
    const currTitle =
      this.props.CardHeaderPropTypes && this.props.CardHeaderPropTypes.title
        ? this.props.CardHeaderPropTypes.title
        : null;
    if (currTitle) {
      if (
        this.state.isMobile &&
        this.props.stepIndex > -1 &&
        this.allowStepsMenu() &&
        this.getAllStatus().length > 0
      ) {
        return (
          <>
            <button
              className={rootClassName + '-steps-mobile-menu-button'}
              onClick={this.toOpenProjectStepsMenu}
            >
              <KeyboardArrowDownIcon
                className={rootClassName + '-steps-mobile-menu-icon'}
              />
              {currTitle}
            </button>
            <ProjectStepsMenu
              open={this.state.projectStepsMenuOpened}
              onClose={this.toCloseProjectStepsMenu}
              anchorEl={this.state.projectStepsMenuAnchor}
              avaliacoes={this.getAllStatus()}
              idProjeto={this.props.projeto.id}
              stepIndex={this.props.stepIndex}
            />
          </>
        );
      } else {
        return currTitle;
      }
    }
    return '';
  }

  render() {
    const cardProps = {
      ...(this.props.CardPropTypes || {}),
      className: getMergedClassNames([
        rootClassName + '-root',
        this.props.CardPropTypes && this.props.CardPropTypes.className
          ? this.props.CardPropTypes.className
          : null,
      ]),
    };
    const cardHeaderProps = {
      ...(this.props.CardHeaderPropTypes || {}),
      title: this.getTitle(),
      className: getMergedClassNames([
        typeof this.props.stepIndex === 'number' && this.props.stepIndex > -1
          ? rootClassName + '-step-header'
          : null,
        this.state.isMobile && typeof this.props.titleHint === 'string'
          ? rootClassName + '-step-header-with-hint'
          : null,
        typeof this.props.CardHeaderPropTypes === 'object' &&
        typeof this.props.CardHeaderPropTypes.className === 'string'
          ? this.props.CardHeaderPropTypes.className
          : '',
      ]),
      subheader: this.getSubHeader(),
    };
    const cardContentProps = {
      ...(this.props.CardContentPropTypes || {}),
    };
    return (
      <Card {...cardProps}>
        <CardHeader {...cardHeaderProps} className='mr-1' />
        <CardContent {...cardContentProps}>{this.props.children}</CardContent>
        {this.getCardActions()}
      </Card>
    );
  }
}

CustomCard.propTypes = {
  CardPropTypes: PropTypes.object,
  CardHeaderPropTypes: PropTypes.object,
  CardContentPropTypes: PropTypes.object,
  cardActionsContentLeft: PropTypes.object,
  cardActionsContentRight: PropTypes.object,
  CardActionsPropTypes: PropTypes.object,
  toPrevCard: PropTypes.func,
  toNextCard: PropTypes.func,
  sending: PropTypes.bool,
  titleHint: PropTypes.string,
  stepIndex: PropTypes.number,
  children: PropTypes.node
};

const mapStateToProps = (state) => ({
  projeto: state.projeto.projetoEditing,
  auth: state.auth,
});

export default connect(mapStateToProps)(CustomCard);
